export default __webpack_public_path__ + "static/media/PPI-firefeature-009.e3054038.jpg";